const animation = require("./winnerIs.json");

module.exports = {
    loop: false,
    autoplay: false,
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'none'
    },
}